<template lang="pug">
BriqPanel(data-test-id="mixed-bookings-panel" v-if="segmentsAreFound")
  h2 Mixed bookings
  p.description How would you like Briq to handle mixed bookings; eg. bookings that contain both children and adults?
  BriqRadio(
    :options="mixOptions"
    v-model="mixedBookingsOption"
    :disabled="disabled"
    )
</template>

<script>
export default {
  name: 'MixedBookingsPanel',
  props: {
    segments: {
      type: Array,
      required: true,
      validator: x => x.length === 2,
    },
    disabled: Boolean,
  },
  data() {
    return {
      mixedBookingsOption: 'notAllowed',
    }
  },
  computed: {
    segmentsAreFound() {
      return !!this.firstSegment && !!this.secondSegment
    },
    firstSegment() {
      return this.segments[0]
    },
    secondSegment() {
      return this.segments[1]
    },
    mixOptions() {
      return {
        addToFirstSegment: `Add to ${this.firstSegment.name}`,
        addToSecondSegment: `Add to ${this.secondSegment.name}`,
        notAllowed: 'Not allowed',
      }
    },
  },
  methods: {
    setSegmentsToExclusive(exclusive) {
      for (const segment of this.segments) {
        segment.exclusive = exclusive
      }
    },
    setMixedBookingsOption() {
      const theyAreAllExclusive = this.segments.map(s => s.exclusive).reduce((a, b) => a && b, true)
      if (theyAreAllExclusive) this.mixedBookingsOption = 'notAllowed'
      else
        this.mixedBookingsOption =
          this.firstSegment.priority < this.secondSegment.priority
            ? 'addToFirstSegment'
            : 'addToSecondSegment'
    },
  },
  created() {
    this.setMixedBookingsOption()
  },
  watch: {
    mixedBookingsOption(newVal) {
      switch (newVal) {
        case 'addToFirstSegment':
          this.setSegmentsToExclusive(false)
          this.firstSegment.priority = 1
          this.firstSegment.exclusive = false
          this.secondSegment.priority = 2
          this.secondSegment.exclusive = true
          break
        case 'addToSecondSegment':
          this.secondSegment.priority = 1
          this.secondSegment.exclusive = false
          this.firstSegment.priority = 2
          this.firstSegment.exclusive = true
          break
        case 'notAllowed':
          this.setSegmentsToExclusive(true)
          this.secondSegment.priority = null
          this.firstSegment.priority = null
          break
      }
    },
  },
  mounted() {
    // TODO: Not fixed when intruducing a third segment different from children and adults
    if (this.mixedBookingsOption === 'notAllowed') {
      this.secondSegment.priority = null
      this.firstSegment.priority = null
    }
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.description
  {typeSmall}
  color #465366

table
  width 100%

td
  padding 17px

tbody
  tr:nth-child(odd)
    background #F1F3F6

.handle
  cursor move
  cursor grab
  margin-right 19px

  &:active
    cursor grabbing
</style>
